@if (configs.columns.length > 0 && gridConfig) {
<div class="assignment-grid">
  <div class="assignment-grid-title">
    <span class="fw-semibold">Primary {{configs.gridName}}</span>
    <span class="ms-3">count: {{count}}</span>
    <span class="ms-3">selected: {{selected}}</span>
  </div>
  <div class="assignment-grid-body">
    <inavista-grid #assignmentsGrid [config]="gridConfig" (rowsSelected)="onRowsSelected($event)" />
  </div>
</div>
}
